"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var RightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M369.05 187.37a48 48 0 0167.65 5.62l208.82 246.66a112 112 0 010 144.75L436.7 831.01a48 48 0 01-73.27-62.04l208.82-246.62a16 16 0 000-20.68L363.44 255.01a48 48 0 015.62-67.64z" } }] }, "name": "right", "theme": "outlined" };
exports.default = RightOutlined;
